import {
  Box,
  Tab,
  TabIndicator,
  TabList,
  TabPanel,
  TabPanels,
  Tabs,
  TabsProps,
} from "@chakra-ui/react";
import { useEffect, useRef, useState } from "react";
import { useLocation } from "react-router-dom";
import { ResellerProfileInterface } from "../../constants/ResellerProfile";
import { useDarkWhiteColor } from "../../themes/colors";
import { TabBankAccount } from "../tab/TabBankAccount";
import { TabResellerProfile } from "./TabResellerProfile";
import { BankInformationInterface } from "../../constants/SupplierProfile";

interface Props extends TabsProps {
  data: ResellerProfileInterface | undefined;
  loaded: boolean;
  onRefresh: VoidFunction;
}

export const TabsResellerRoot = ({
  data,
  loaded,
  onRefresh,
  ...rest
}: Props) => {
  const [tabIndex, setTabIndex] = useState<number>(0);
  const [bankInfo, setBankinfo] = useState<
    BankInformationInterface | undefined
  >(undefined);

  const location = useLocation();
  const tabsRef = useRef<HTMLDivElement | null>(null);
  const bgBnw = useDarkWhiteColor();

  const queryParams = new URLSearchParams(location.search);
  const typeParams = queryParams.get("type") || "";

  useEffect(() => {
    typeParams === "changeBankAccount" && moveToBankAccount(1);
  }, [typeParams]);

  useEffect(() => {
    if (typeParams === "changeBankAccount") {
      const timer = setTimeout(() => {
        if (tabsRef.current) {
          tabsRef.current.scrollIntoView({
            behavior: "smooth",
            block: "start",
          });
        }
      }, 100);

      return () => clearTimeout(timer);
    }
  }, [typeParams]);

  useEffect(() => {
    const obj: BankInformationInterface = {
      acc_name: data?.acc_name,
      acc_number: data?.acc_number,
      bank_name: data?.bank_name,
    };

    setBankinfo(obj);
  }, [data]);

  const moveToBankAccount = (index: number) => {
    setTabIndex(index);
  };

  const menuTab = [
    {
      id: 1,
      name: "Profil Reseller",
      element: (
        <TabResellerProfile
          data={data}
          loaded={loaded}
          onRefresh={() => onRefresh()}
        />
      ),
    },
    {
      id: 2,
      name: "Rekening Reseller",
      element: <TabBankAccount data={bankInfo} loaded={loaded} pageType={2} />,
    },
  ];

  return (
    <Box ref={tabsRef}>
      <Tabs
        index={tabIndex}
        onChange={moveToBankAccount}
        w={"100%"}
        p={2}
        bg={bgBnw}
        borderRadius={"md"}
        position="relative"
        variant="unstyled"
        size={"sm"}
        {...rest}
      >
        <TabList>
          {menuTab.map((item) => (
            <Tab key={item.id}>{item.name}</Tab>
          ))}
        </TabList>

        <TabIndicator
          mt="-1.5px"
          height="2px"
          bg="red.400"
          borderRadius="1px"
        />

        <TabPanels>
          {menuTab.map((item) => (
            <TabPanel key={item.id}>{item.element}</TabPanel>
          ))}
        </TabPanels>
      </Tabs>
    </Box>
  );
};
